// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
/** Formats a period as its "YYYY-MM" key, such as "2024-01". */
export function toPeriodKey(period: { year: number; month: number }): string {
  return `${period.year.toString()}-${period.month.toString().padStart(2, '0')}`;
}
